var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('b-navbar',{attrs:{"type":"light","variant":"light"}},[_c('b-navbar-brand',{attrs:{"href":"#"},on:{"click":function($event){return _vm.home()}}},[_c('h4',[_vm._v("Oh God, are you true?")])])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }